export const GET_LIST = '/additional-cost/get_list';
export const SHOW_DATA = '/additional-cost/show_data';
export const CREATE_DATA = '/additional-cost/create_data';
export const UPDATE_DATA = '/additional-cost/update_data';
export const REMOVE_DATA = '/additional-cost/remove_data';
export const GET_ADDITIONAL_COST_LIST = '/additional-cost/get_additional_cost_list';


export const FORM_DATA = {
  name: '',
  description: '',
  is_active: false,
};